import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import 'intersection-observer';

ReactDOM.render(<App />, document.getElementById('root'));